export default __webpack_public_path__ + "static/media/ugx.fea299af.png";